import { connect } from 'react-redux'
import { compose } from 'recompose'

import { createErrorToasterMessage } from 'data/ui/actions'
import { dataFetched, makesMutations } from 'data/graphql'
import { applyTemplateOnNote as applyTemplateOnNoteQuery } from 'remote/notes'

const providesApplyTemplateOnNote = compose(
  connect(
    null,
    { dataFetched, createErrorToasterMessage }
  ),
  makesMutations({
    query: applyTemplateOnNoteQuery,
    mutationPropName: 'applyTemplateOnNote',
    getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
      dataFetched(result.data.applyTemplateOnNote)
      return result
    },
    getOnErrorFromProps: ({ createErrorToasterMessage }) => ({ error }) => {
      createErrorToasterMessage({ title: error.message })
    },
  })
)

export default providesApplyTemplateOnNote
